/* global window */
import React from 'react';
import PropTypes from 'prop-types';

function HiddenTable(props) {
	const {
		tableData,
		caption,
		settings
	} = props;
	const { format } = window;
	const tableRows = [];
	let index = 0;
	const data = typeof tableData === 'string' ? JSON.parse(tableData) : tableData;

	Object.keys(data).forEach(date => {
		const columnData = data[date];
		const cells = [];
		if (columnData) {
			settings.forEach((col, setIndex) => {
				const { formatFunc, dataPoint, isMsDate } = col;
				let dataVal = columnData[dataPoint];
				const key = `sr-table-cell-${caption}-${dataPoint}-${dataVal}-${setIndex}`;

				if (isMsDate && dataVal) {
					dataVal = format.moment.fromOADate(dataVal).format();
				}

				cells.push(
					<td key={key}>{format[formatFunc](dataVal)}</td>
				);
			});
		}
		tableRows.push(
			<tr key={`sr-table-row-${index}-${caption}`}>
				{cells}
			</tr>
		);
		index += 1;
	});
	return (
		<figcaption className="sr-only">
			<table>
				<caption>{caption}</caption>
				<thead>
					<tr>
						{settings.map(col => {
							const { label } = col;
							return <th scope="col" key={`sr-table-header-${caption}-${label}`}>{label}</th>;
						})}
					</tr>
				</thead>
				<tbody>
					{tableRows}
				</tbody>
			</table>
		</figcaption>
	);
}

/**
 * Helpful info for adding prop types
 * https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
 */
HiddenTable.propTypes = {
	tableData: PropTypes.oneOfType(
		[PropTypes.string, PropTypes.object, PropTypes.arrayOf(PropTypes.object)]
	),
	caption: PropTypes.string,
	settings: PropTypes.arrayOf(PropTypes.object).isRequired
};

HiddenTable.defaultProps = {
	tableData: {},
	caption: ''
};

export default HiddenTable;
